import { Iconography, LinkButton } from '../../components/primitives';
import Alert from '../../components/ui/Alert';
import { RemovedItem } from '../../hooks/cartHook';
import { testId } from '../../utils';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

type AddBackProps = {
  item: RemovedItem;
  addBack: (item: RemovedItem) => void;
  dismiss: (item: RemovedItem) => void;
};

export const AddBack = ({ item, addBack, dismiss }: AddBackProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.cart' });

  const onAddBack = React.useCallback(() => {
    addBack(item);
  }, [item, addBack]);

  const onDismiss = React.useCallback(() => {
    dismiss(item);
  }, [item, dismiss]);

  return (
    <Alert variant="success" {...testId('add-back-alert', `${item.projectId}`)}>
      {t('item_removed', { title: item.title })}
      <LinkButton
        {...testId('add-back-alert', `${item.projectId}`, 'add')}
        onClick={onAddBack}
      >
        {t('add_back')}
      </LinkButton>
      <div className="ml-auto">
        <button
          {...testId('add-back-alert', `${item.projectId}`, 'close')}
          onClick={onDismiss}
        >
          <Iconography variant="close" style="rounded" className="text-base" />
        </button>
      </div>
    </Alert>
  );
};
